import { render, staticRenderFns } from "./POD-10-2023AnyObjectView.vue?vue&type=template&id=bf235696&scoped=true&"
import script from "./POD-10-2023AnyObjectView.vue?vue&type=script&lang=js&"
export * from "./POD-10-2023AnyObjectView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf235696",
  null
  
)

export default component.exports